import glamorous from 'glamorous';
import mediaQueries from "../../styles/media-queries";
import editor from "../../styles/editor";

export default glamorous.h1({
    ...editor.title,
    marginBottom: "35px",

    [mediaQueries.desktop]: {
        ...editor.title[mediaQueries.desktop],
        maxWidth: "500px",
        margin: "0 auto",
        width: "auto",
        marginBottom: "55px"
    }
});


// WEBPACK FOOTER //
// ./src/components/common/Heading.js